// TelcoTrack - Guest Guard
// Prevents authenticated users from accessing login/register pages
// Redirects them to the Dashboard přehled instead

import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.authService.isLoggedIn()) {
      return this.router.parseUrl('/dashboard');
    }
    return true;
  }
}
